import Dialog from "@stimulus-components/dialog"

export default class extends Dialog {
    static targets = ['dialog']

    connect() {
        super.connect()

        // contact radio list
        this.contactRadioList = this.dialogTarget.querySelectorAll(".gm-popup-form-line-option input[type=radio]")
        this.contactRadioListWrapper = this.dialogTarget.querySelectorAll(".wpcf7-list-item")

        this.contactRadioList.forEach(r => r.addEventListener('change', () => {
            this.contactRadioListWrapper.forEach(w => w.classList.remove('first'))
            r.parentNode.parentNode.classList.add('first')
        }))

        // Phone fields
        this.phoneInput = this.dialogTarget.querySelector('.gm-popup-form #phone')
        this.phoneInput2 = this.dialogTarget.querySelector('.gm-popup-form #phone2')
        this.hiddenPhoneInput3 = this.dialogTarget.querySelector('.gm-popup-form #phone3')

        if (this.phoneInput) this.phoneInput.addEventListener('change', () => {
            if (this.phoneInput2) this.phoneInput2.value = this.phoneInput.value
            this.hiddenPhoneInput3.value = this.phoneInput.value
        })

        if (this.phoneInput2) phoneInput2.addEventListener('change', () => {
            if (this.phoneInput) this.phoneInput.value = this.phoneInput2.value
            this.hiddenPhoneInput3.value = this.phoneInput2.value
        })

        // Email fields
        this.emailInput = this.dialogTarget.querySelector('.gm-popup-form #email')
        this.emailInput2 = this.dialogTarget.querySelector('.gm-popup-form #email2')
        this.hiddenEmailInput3 = this.dialogTarget.querySelector('.gm-popup-form #email3')

        if (this.emailInput) this.emailInput.addEventListener('change', () => {
            if (this.emailInput2) this.emailInput2.value = this.emailInput.value
            this.hiddenEmailInput3.value = this.emailInput.value
        })

        if (this.emailInput2) this.emailInput2.addEventListener('change', () => {
            if (this.emailInput) this.emailInput.value = this.emailInput2.value
            this.hiddenEmailInput3.value = this.emailInput2.value
        })

        // Message fields
        this.messageInput = this.dialogTarget.querySelector('.gm-popup-form #message')
        this.messageInput2 = this.dialogTarget.querySelector('.gm-popup-form #message2')
        this.hiddenMessageInput3 = this.dialogTarget.querySelector('.gm-popup-form #message3')

        if (this.messageInput) this.messageInput.addEventListener('change', () => {
            if (this.messageInput2) this.messageInput2.value = this.messageInput.value
            this.hiddenMessageInput3.value = this.messageInput.value
        })

        if (this.messageInput2) this.messageInput2.addEventListener('change', () => {
            if (this.messageInput) this.messageInput.value = this.messageInput2.value
            this.hiddenMessageInput3.value = this.messageInput2.value
        })
    }

    // Function to override on open.
    // open() {
    //     super.open()
    // }

    // Function to override on close.
    // close() {
    //     super.close()
    // }

    // Function to override on backdropClose.
    // backdropClose() {
    //     super.backdropClose()
    // }
}